import React, {Suspense} from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Financials from '../../pages/admin/finance/Financials';
import MonthlyFinancials from '../../pages/admin/finance/MonthlyFinancials';

const Finance = (props) => {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}/:year/:month`} component={MonthlyFinancials}/>
        <Route exact path={`${path}`} component={Financials}/>
      </Switch>
    </Suspense>
	)
}

export default Finance;
